export default "__VITE_ASSET__BHcAjkiJ__"